
import React, { useEffect, useState } from 'react';

import { apiCall } from '../api';


const Pictures = ({ title, app }) => {

    const fontClass = app === 'mikey' ? 'mikey' : 'ella';

    const [currentImages, setCurrentImages] = useState([]);

    const [refresh, setRefresh] = useState(false);

    const [newCaption, setNewCaption] = useState('');
    const [newAuthor, setNewAuthor] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const formatDate = (date) => {

        const dateObj = new Date(date);

        return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
    }

    useEffect(() => {

        const getUpdates = async () => {

            const [success, resp] = await apiCall({
                method: 'get',
                url: '/mikeyandeleanor/api/images/',
                params: {
                    app: app
                }
            });

            if (success) setCurrentImages(resp);
            
        };

        getUpdates();


    }, [refresh]);

    const handleUpload = async () => {
        if (!selectedFile) return;

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('app', app);
        formData.append('caption', newCaption);
        formData.append('author', newAuthor);

        const [success, resp] = await apiCall({
            method: 'post',
            url: '/mikeyandeleanor/images/submit_image/',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (success) {
            setRefresh(!refresh);
        }
    };


    const renderImages = () => {

        return currentImages.map((image, index) => {
            return (
                <div
                style={{
                    margin: 'auto'
                }}>

                    <img
                    key={index}
                    src={image.image_url}
                    alt={image.caption}
                    className='pictures-picture'
                    />
                    <div
                    className='pictures-caption'>
                        {image.caption}
                        </div>
                    <div
                    className='pictures-author'>
                        {`- ${image.author} - ${formatDate(image.date_added)}`}
                    </div>

                </div>
                
            )
        });


    };


    return (

        <div
        className='pictures-container'
        >

            <div
            className={`pictures-title ${fontClass}`}>
                {title}
            </div>

            <div 
            className='pictures-content'>
                { renderImages() }
            </div>

            <div
            className='updates-post'>

                <input
                    type="file"
                    accept="image/*"
                    className='update-button'
                    onChange={handleFileChange}
                    />

                <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '10px',
                }}>
                    <input
                    className='update-input'
                    placeholder='write a caption...'
                    onChange={(e) => setNewCaption(e.target.value)}
                    />
                    <input
                    className='author-input'
                    placeholder='author'
                    onChange={(e) => setNewAuthor(e.target.value)}
                />


                </div>

                
                <button
                className='update-button'
                onClick={() => handleUpload()}   
                >
                    Upload
                </button>
                


            </div>





        </div>
    )


};

export default Pictures;